import { Form, Select, type SelectProps } from "antd";
import React, { useMemo } from "react";
import { type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import { type DefaultOptionType } from "antd/es/cascader";
import { type Client } from "../../generated-axios-client";
import type { IntlShape } from "@formatjs/intl";

const clientSelectOptions = (clientItems: Client[]) => {
  const clientOptions = clientItems.map((item) => ({
    key: item.id,
    value: item.id,
    label: item.legal_name,
  }));

  return clientOptions;
};

const clientSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
  const search = input.toLowerCase();
  const value = option?.label?.toString().toLowerCase?.() ?? "";

  return value.includes(search);
};

type ClientSelectFormItemProps = {
  intl: IntlShape;
  clientItems: Client[];
  rules?: Rule[];
  placeholder?: string | boolean;
  selectProps?: SelectProps<string>;
};

export const ClientSelectorFormItem = (props: ClientSelectFormItemProps) => {
  const { intl, clientItems, rules = [], placeholder = false, selectProps } = props;

  const options = useMemo(() => clientSelectOptions(clientItems ?? []), [clientItems]);

  return (
    <Form.Item
      name="client"
      label={intl.formatMessage({ id: "filter_label_client" })}
      rules={rules}
    >
      <Select
        placeholder={placeholder}
        showSearch={true}
        options={options}
        filterOption={clientSearchHandler}
        {...selectProps}
      />
    </Form.Item>
  );
};
